export default "__VITE_PUBLIC_ASSET__2926e4ca__"